<template>
  <div class="auth-callback-page">
    <div class="cloud-auth-bg"></div>

    <div class="auth-callback-card">
      <div class="auth-callback-icon" :class="status">
        <b-spinner v-if="status === 'loading' || status === 'linking'" small />
        <i v-else :class="iconClass"></i>
      </div>

      <h2 class="auth-callback-title">
        {{ title }}
      </h2>
      <p class="auth-callback-desc">
        {{ message }}
      </p>

      <button
        v-if="status === 'fail'"
        class="auth-callback-button"
        type="button"
        @click="goBack"
      >
        返回登录页
      </button>
    </div>
  </div>
</template>

<script>
import { BSpinner } from "bootstrap-vue";

export default {
  components: {
    BSpinner,
  },
  data() {
    return {
      status: "loading",
      title: "正在授权",
      message: "正在验证授权信息...",
      code: "",
      state: "",
      redirectTimer: null,
    };
  },
  computed: {
    iconClass() {
      return this.status === "success"
        ? "el-icon-success"
        : "el-icon-warning-outline";
    },
  },
  mounted() {
    this.code = this.$route?.query?.code || "";
    this.state = this.$route?.query?.state || "";

    this.$http
      .post("/Account/AuthLogin", {
        code: this.code,
        state: this.state,
      })
      .then((u) => {
        if (u.status === 1) {
          this.status = "success";
          this.title = "授权成功";
          this.message = "正在登录...";
          this.$setToken(u);
          this.redirectTimer = setTimeout(() => {
            this.$router.replace({
              name: "home",
            });
          }, 800);
        } else {
          this.status = "linking";
          this.title = "即将关联账号";
          this.message = "授权已完成，请继续关联平台账号...";
          this.redirectTimer = setTimeout(() => {
            this.$router.replace({
              name: "Login",
              query: {
                openid: u.openid || u.open_id,
              },
            });
          }, 800);
        }
      })
      .catch((u) => {
        this.status = "fail";
        this.title = "授权失败";
        this.message = u?.message || "授权信息校验失败，请返回后重试。";
      });
  },
  beforeDestroy() {
    if (this.redirectTimer) {
      clearTimeout(this.redirectTimer);
      this.redirectTimer = null;
    }
  },
  methods: {
    goBack() {
      this.$router.replace({
        name: "Login",
      });
    },
  },
};
</script>

<style lang="scss">
.auth-callback-page {
  position: relative;
  display: flex;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 24px;
}

.auth-callback-card {
  position: relative;
  z-index: 1;
  width: min(100%, 310px);
  padding: 60px 34px 70px;
  border: 1px solid rgba(255, 255, 255, 0.58);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.64);
  box-shadow: 0 16px 80px rgba(87,119,165,.12),
    inset 0 1px 0 hsla(0,0%,100%,.76);
  text-align: center;
  backdrop-filter: blur(22px) saturate(140%);
  -webkit-backdrop-filter: blur(22px) saturate(140%);
  margin-top: -100px;
}

.auth-callback-icon {
  display: inline-flex;
  width: 58px;
  height: 58px;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
  border-radius: 50%;
  background: rgba(64, 158, 255, 0.12);
  color: #409eff;
  font-size: 42px;
}

.auth-callback-icon.success {
  background: rgba(103, 194, 58, 0.12);
  color: #67c23a;
}

.auth-callback-icon.fail {
  background: rgba(230, 162, 60, 0.12);
  color: #e6a23c;
}

.auth-callback-title {
  margin: 0 0 12px;
  color: #24364a;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0;
}

.auth-callback-desc {
  min-height: 48px;
  margin: 0;
  color: #65758a;
  font-size: 14px;
  line-height: 1.7;
}

.auth-callback-button {
  height: 40px;
  min-width: 120px;
  margin-top: 22px;
  border: none;
  border-radius: 4px;
  background: #409eff;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.auth-callback-button:hover {
  background: #66b1ff;
}
</style>
